module.exports = __webpack_public_path__ + "images/sprites/ui/icon_watch_dbe166d5858608ee9f44e825ef3d6b24.png";